import { render, staticRenderFns } from "./ImmediateDiscountPrice.vue?vue&type=template&id=79a23534&scoped=true&"
import script from "./ImmediateDiscountPrice.vue?vue&type=script&lang=ts&"
export * from "./ImmediateDiscountPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a23534",
  null
  
)

export default component.exports